import React from 'react';
import PropTypes from 'prop-types';
import fp from 'lodash/fp';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { ButtonBase, Icon } from '@deerplusofficial/pos-components';
import { mapState, color } from '@deerplusofficial/pos-helper';
import actions from '../../actions';
import withResetPos from '../../assist/withResetPos';

const Container = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 24px;
  background-color: ${color.accent};
  border-bottom: solid 1px ${color.border};
  color: white;
`;

const Cancel = styled(ButtonBase)`
  margin-right: 8px;
  color: currentColor;
`;

const Text = styled.div`
  flex-grow: 1;
`;

class CartPreOrderStatus extends React.PureComponent {
  static propTypes = {
    preOrder: PropTypes.shape(),
  };

  static defaultProps = {
    preOrder: {},
  };

  onClose = () => {
    const { resetDetail, resetPos } = this.props;
    resetDetail();
    resetPos();
  };

  render() {
    const {
      preOrder: { name },
    } = this.props;

    return (
      <Container>
        <Cancel onClick={this.onClose}>
          <Icon icon="times" />
        </Cancel>
        <Text>指定訂單：{name}</Text>
      </Container>
    );
  }
}

const {
  detail: { reset: resetDetail },
} = actions.preOrder;

export default fp.compose(
  connect(
    mapState(['preOrder']),
    { resetDetail }
  ),
  withResetPos()
)(CartPreOrderStatus);



// WEBPACK FOOTER //
// ./src/components/Cart/CartPreOrderStatus.js